// Example locale file for Italian, give this to your locale team to translate

export const AG_GRID_LOCALE_IT = {
    // Set Filter
    selectAll: '(Seleziona tutto)',
    selectAllSearchResults: '(Seleziona tutti i risultati della ricerca)',
    searchOoo: 'Cerca...',
    blanks: '(Vuoto)',
    noMatches: 'Nessuna corrispondenza',

    // Number Filter & Text Filter
    filterOoo: 'Filtro...',
    equals: 'Uguale a',
    notEqual: 'Diverso da',
    blank: 'Vuoto',
    notBlank: 'Non vuoto',
    empty: 'Scegli uno',

    // Number Filter
    lessThan: 'Minore di',
    greaterThan: 'Maggiore di',
    lessThanOrEqual: 'Minore o uguale a',
    greaterThanOrEqual: 'Maggiore o uguale a',
    inRange: 'Tra',
    inRangeStart: 'da',
    inRangeEnd: 'a',

    // Text Filter
    contains: 'Contiene',
    notContains: 'Non contiene',
    startsWith: 'Inizia con',
    endsWith: 'Termina con',

    // Date Filter
    dateFormatOoo: 'aaaa-mm-gg',

    // Filter Conditions
    andCondition: 'E',
    orCondition: 'O',

    // Filter Buttons
    applyFilter: 'Applica',
    resetFilter: 'Ripristina',
    clearFilter: 'Rimuovi',
    cancelFilter: 'Cancella',

    // Filter Titles
    textFilter: 'Filtra per testo',
    numberFilter: 'Filtra per numeri',
    dateFilter: 'Filtra per Data',
    setFilter: 'Imposta filtro',

    // Side Bar
    columns: 'Colonne',
    filters: 'Filtri',

    // columns tool panel
    pivotMode: 'Tabella pivot',
    groups: 'Row Groups',
    rowGroupColumnsEmptyMessage: 'Trascina qui per impostare i gruppi di righe',
    values: 'Valori',
    valueColumnsEmptyMessage: 'Trascina qui per aggregare',
    pivots: 'Etichetta colonne',
    pivotColumnsEmptyMessage: 'Trascina qui per impostare etichetta colonne',

    // Header of the Default Group Column
    group: 'Gruppo',

    // Row Drag
    rowDragRows:'Righe',

    // Other
    loadingOoo: 'Caricamento…',
    noRowsToShow: 'Nessuna riga da mostrare',
    enabled: 'Abilitato',

    // Menu
    pinColumn: 'Blocca colonna',
    pinLeft: 'Blocca sinistra',
    pinRight: 'Blocca destra',
    noPin: 'Sblocca',
    valueAggregation: 'Aggrega valori',
    autosizeThiscolumn: 'Autodimensiona questa colonna',
    autosizeAllColumns: 'Autodimensiona tutte le colonne',
    groupBy: 'Ragruppa per',
    ungroupBy: 'Disaggrega ',
    addToValues: 'Add ${variable} to values',
    removeFromValues: 'Remove ${variable} from values',
    addToLabels: 'Add ${variable} to labels',
    removeFromLabels: 'Remove ${variable} from labels',
    resetColumns: 'Reset Columns',
    expandAll: 'Espandi tutto',
    collapseAll: 'Chiudi tutto',
    copy: 'Copia',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copia con intestazioni',
    copyWithHeaderGroups: 'Copia con gruppi di intestazione',
    paste: 'Incolla',
    ctrlV: 'Ctrl+V',
    export: 'Esporta',
    csvExport: 'Esporta CSV',
    excelExport: 'Esporta Excel',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Somma',
    min: 'Min',
    max: 'Max',
    none: 'Nessuno',
    count: 'Conta numeri',
    avg: 'Media',
    filteredRows: 'Filtrato',
    selectedRows: 'Selezionato',
    totalRows: 'Totale Righe',
    totalAndFilteredRows: 'Righe',
    more: 'Altro',
    to: 'to',
    of: 'of',
    page: 'Pagina',
    nextPage: 'Prossima pagina',
    lastPage: 'Ultima pagina',
    firstPage: 'Prima pagina',
    previousPage: 'Pagina precedente',

    // Pivoting
    pivotColumnGroupTotals: 'Totale',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Tabella pivot',
    chartRange: 'Chart Range',

    columnChart: 'Column',
    groupedColumn: 'Grouped',
    stackedColumn: 'Stacked',
    normalizedColumn: '100% Stacked',

    barChart: 'Grafico a barre',
    groupedBar: 'Grouped',
    stackedBar: 'Stacked',
    normalizedBar: '100% Stacked',

    pieChart: 'Grafico a torta',
    pie: 'Torta',
    doughnut: 'Anello',

    line: 'Grafico a linee',

    xyChart: 'Grafico a dispersione (XY)',
    scatter: 'Dispersione',
    bubble: 'Bolle',

    areaChart: 'Grafico ad area',
    area: 'Area',
    stackedArea: 'Area in pila',
    normalizedArea: 'Area 100% in pila',

    histogramChart: 'Istogramma',

    combinationChart: 'Combination',
    columnLineCombo: 'Column & Line',
    AreaColumnCombo: 'Area & Column',

    // Charts
    pivotChartTitle: 'Tabella pivot',
    rangeChartTitle: 'Range Chart',
    settings: 'Impostazioni',
    data: 'Dati',
    format: 'Formato',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Larghezza',
    height: 'Altezza',
    length: 'Lunghezza',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Grafico',
    title: 'Titolo',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Labels',
    size: 'Size',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normale',
    bold: 'Grassetto',
    italic: 'Corsivo',
    boldItalic: 'Corsivo grassetto',
    predefined: 'Predefinito',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Colonna',
    barGroup: 'Barra',
    pieGroup: 'Torta',
    lineGroup: 'Linea',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Istogramma',
    combinationGroup: 'Combination',
    groupedColumnTooltip: 'Colonne ragruppate',
    stackedColumnTooltip: 'Colonne in pila',
    normalizedColumnTooltip: 'Colonne 100% in pila',
    groupedBarTooltip: 'Barre ragruppate',
    stackedBarTooltip: 'Barre in pila',
    normalizedBarTooltip: 'Barre 100% in pila',
    pieTooltip: 'Torta',
    doughnutTooltip: 'Anello',
    lineTooltip: 'Linea',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    columnLineComboTooltip: 'Column & Line',
    areaColumnComboTooltip: 'Area & Column',
    customComboTooltip: 'Custom Combination',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
    chartSettingsToolbarTooltip: 'Menu',
    chartLinkToolbarTooltip: 'Linked to Grid',
    chartUnlinkToolbarTooltip: 'Unlinked from Grid',
    chartDownloadToolbarTooltip: 'Download Chart',
    seriesChartType: 'Series Chart Type',
    seriesType: 'Series Type',
    secondaryAxis: 'Secondary Axis',

    // ARIA
    ariaHidden: 'hidden',
    ariaVisible: 'visible',
    ariaChecked: 'checked',
    ariaUnchecked: 'unchecked',
    ariaIndeterminate:'indeterminate',
    ariaDefaultListName: 'List',
    ariaColumnSelectAll: 'Toggle Select All Columns',
    ariaInputEditor: 'Input Editor',
    ariaDateFilterInput: 'Date Filter Input',
    ariaFilterList: 'Filter List',
    ariaFilterInput: 'Filter Input',
    ariaFilterColumnsInput: 'Filter Columns Input',
    ariaFilterValue: 'Filter Value',
    ariaFilterFromValue: 'Filter from value',
    ariaFilterToValue: 'Filter to value',
    ariaFilteringOperator: 'Filtering Operator',
    ariaColumn: 'Column',
    ariaColumnList: 'Column List',
    ariaColumnGroup: 'Column Group',
    ariaRowSelect: 'Press SPACE to select this row',
    ariaRowDeselect: 'Press SPACE to deselect this row',
    ariaRowToggleSelection: 'Press Space to toggle row selection',
    ariaRowSelectAll: 'Press Space to toggle all rows selection',
    ariaToggleVisibility: 'Press SPACE to toggle visibility',
    ariaSearch: 'Search',
    ariaSearchFilterValues: 'Search filter values',

    ariaRowGroupDropZonePanelLabel: 'Row Groups',
    ariaValuesDropZonePanelLabel: 'Values',
    ariaPivotDropZonePanelLabel: 'Column Labels',
    ariaDropZoneColumnComponentDescription: 'Press DELETE to remove',
    ariaDropZoneColumnValueItemDescription: 'Press ENTER to change the aggregation type',

    // ARIA Labels for Dialogs
    ariaLabelColumnMenu: 'Column Menu',
    ariaLabelCellEditor: 'Cell Editor',
    ariaLabelDialog: 'Dialog',
    ariaLabelSelectField: 'Select Field',
    ariaLabelTooltip: 'Tooltip',
    ariaLabelContextMenu: 'Context Menu',
    ariaLabelSubMenu: 'SubMenu',
    ariaLabelAggregationFunction: 'Aggregation Function',

    // Number Format (Status Bar, Pagination Panel)
    thousandSeparator: ',',
    decimalSeparator: '.',

}